import { Component, OnInit, HostListener } from '@angular/core';

@Component({
  selector: 'app-nav-panel',
  templateUrl: './nav-panel.component.html',
  styleUrls: ['./nav-panel.component.scss']
})
export class NavPanelComponent implements OnInit {

  windowsWidth;
  navActive;

  navData = [
    {
      head: 'PROFILE',
      number: '01',
      title: 'ZEN AND THE ART OF ANJALI PATIL',
      subOne: 'Written by Nolina S. Minj',
      subTwo: 'Photographed by Farhan Hussain at Feat.Artists',
      expanded: false,
      extraText: 'The actor reconciles her ambition with the Indian film industry’s fundamental inequities',
      link: '/anjali-patil-cover-story'
    },
    {
      head: 'ROUND TABLE',
      number: '02',
      title: 'THE SUM OF THEIR PARTS',
      subOne: 'Written and moderated by Anuj Malhotra',
      expanded: false,
      extraText: 'An examination of the specific appearance of truth within four Netflix releases',
      link: '/netflix-india-storytelling'
    },
    {
      head: 'OPINION',
      number: '03',
      title: 'ODD MEN OUT',
      subOne: 'Written by Aakshi Magazine',
      subTwo: 'Illustrated by Aditya Dutta',
      expanded: false,
      extraText: ' atypical representation of masculinity is also an attempt to reset the course of male stardom',
      extraText1: 'Gulabo Sitabo\'s',
      link: '/gulabo-sitabo-masculinity'
    },
    {
      head: 'DIALOGUE',
      number: '04',
      title: 'IN CRITICAL CONDITION',
      subOne: 'Written and moderated by Sadaf Shaikh',
      subTwo: 'Illustrated by Aishwaryashree',
      expanded: false,
      extraText: 'A seasoned critic and two podcasters consider the shape-shifting nature of movie reviewing as new digital forums for discussing films continue to open up',
      link: '/contemporary-film-reviewing'
    },
    {
      head: 'ESSAY',
      number: '05',
      title: 'RISE AND FALL',
      subOne: 'Written by Akshaya Pillai',
      subTwo: 'Photographed by Lekha Rathnam',
      expanded: false,
      extraText: 'The South Indian half sari has been reduced to a mere prop in Malayalam films ever since the garment lost favour in Kerala',
      link: '/half-sari-malayalam-cinema'
    },
    {
      head: 'VIDEO ESSAY',
      number: '06',
      title: 'EYES OF THE BEHOLDER',
      subOne: 'Video curation and text by Preksha Sharma',
      subTwo: 'Video editing by Viral Shah',
      expanded: false,
      extraText: 'Film-maker Bishakha Datta contemplates the distinct gazes of three creators through their latest works',
      link: '/bishakha-datta-sex-gaze'
    },
    {
      head: 'SELF-PORTRAIT',
      number: '07',
      title: 'A VIEW WITH A ROOM',
      subOne: 'Written, directed and performed by Ankit Verma',
      subTwo: 'Filmed by Joshua Navalkar',
      expanded: false,
      extraText: 'Performance art finds synergy with the camera, blurring the borders between art and life through experimental storytelling',
      link: '/performance-art-ankit-verma'
    },
    {
      head: 'INTERMISSION',
      number: '08',
      title: 'LOVE LANGUAGE',
      subOne: 'Written and illustrated by Veer Misra',
      expanded: false,
      extraText: 'An artistic reflection on the connected visual subtext of queer intimacy and Hindi film songs',
      link: '/queer-intimacy-hindi-songs'
    },
    {
      head: 'LIST',
      number: '09',
      title: 'ADULTS ONLY',
      subOne: 'Written by Vasu Primlani',
      expanded: false,
      extraText: 'A comedian unexpectedly finds inspiration in the sophisticated humour of Western animated films and rates her top picks',
      link: '/vasu-primlani-animated-comedy'
    },
    {
      head: 'FIRST PERSON',
      number: '10',
      title: 'SENSE AND SENSITIVITY',
      subOne: 'As told to Shirin Mehta',
      subTwo: 'Illustrated by Ananya Arya',
      expanded: false,
      extraText: 'Five people recount their experiences of watching on-screen depictions of the mental illnesses they live with',
      link: '/mental-health-indian-films'
    }
  ];

  navSubData = [
    {
      head: 'SPOTLIGHT',
      number: '11',
      title: 'HOME ALONE',
      subOne: 'Written by Uday Kapur',
      expanded: false,
      link: '/gucci-nick-cave'
    },
    {
      head: 'DESIGNER\'S CUT',
      number: '12',
      title: 'COSTUME DRAMA',
      subOne: 'Written by Shirin Mehta',
      expanded: false,
      link: '/gabrielle-chanel-costume-design'
    },
    {
      head: 'BRAND FOCUS',
      number: '13',
      title: 'AQUATICALLY INCLINED',
      expanded: false,
      link: '/breguet-marine-haute-joaillerie'
    }
  ];

  constructor() { }

  ngOnInit() {
    this.windowsWidth = window.innerWidth;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowsWidth = window.innerWidth;
  }

}
